export const compressImage = (file: File, maxWidth = 1024, quality = 0.7): Promise<File> => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    const reader = new FileReader()

    reader.onload = e => {
      image.src = e.target?.result as string
    }

    image.onload = () => {
      const canvas = document.createElement('canvas')
      const scaleFactor = maxWidth / image.width
      canvas.width = maxWidth
      canvas.height = image.height * scaleFactor

      const ctx = canvas.getContext('2d')
      if (!ctx) return reject('Erro ao criar contexto do canvas.')

      ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

      const originalType = file.type === 'image/png' ? 'image/png' : 'image/jpeg'

      canvas.toBlob(
        blob => {
          if (!blob) return reject('Falha ao comprimir imagem.')

          const extension = originalType === 'image/png' ? 'png' : 'jpeg'
          const newFileName = file.name.replace(/\.(jpg|jpeg|png)$/, `.${extension}`)

          const compressedFile = new File([blob], newFileName, { type: originalType })
          resolve(compressedFile)
        },
        originalType,
        quality // qualidade aplicável ao JPEG (para PNG é ignorado)
      )
    }

    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}
